import React from 'react';
import { database } from '../data/database.ts';

const About: React.FC = () => {

  const db = database.about;

  return (
    <section id="about" className="about section">
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row align-items-xl-center gy-5">
          <div className="col-xl-12 content">
            <h2 className="section-title text-center pb-3 sitename">{db.title}</h2>
            <blockquote className="section-content">{db.description}</blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
